module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "container auth-view-wrapper"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logo.png"),
      "alt": "Reev"
    }
  }), _c('fieldset', [_c('legend', {
    staticClass: "login-legend"
  }, [_vm._v("Ative sua conta")]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.apiErrorMessages), function(errorMessage, idx) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.apiErrorMessages.length > 0),
        expression: "apiErrorMessages.length > 0"
      }],
      key: idx,
      staticClass: "error-message"
    }, [_vm._v(_vm._s(errorMessage))])
  }), 0), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-email",
      "type": "email",
      "name": "email",
      "disabled": "",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "change": function($event) {
        _vm.email = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('name')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-name",
      "type": "name",
      "name": "name",
      "placeholder": "Nome"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  }), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    key: "name",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), (_vm.user.default_user) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [((_vm.showPassword ? 'text-open-password' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-password",
      "name": "password",
      "placeholder": "Senha",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.user.password) ? _vm._i(_vm.user.password, null) > -1 : (_vm.user.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "password", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "password", $$c)
        }
      }
    }
  }) : ((_vm.showPassword ? 'text-open-password' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-password",
      "name": "password",
      "placeholder": "Senha",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.user.password, null)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "password", null)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6'),
      expression: "'required|min:6'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-password",
      "name": "password",
      "placeholder": "Senha",
      "type": _vm.showPassword ? 'text-open-password' : 'password'
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), (_vm.showPassword) ? _c('div', {
    staticClass: "input-group-addon open-password"
  }, [_c('img', {
    staticClass: "icon-size",
    attrs: {
      "src": require("../../assets/images/icons/open-eye.svg")
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  })]) : _c('div', {
    staticClass: "input-group-addon open-password"
  }, [_c('img', {
    staticClass: "icon-size",
    attrs: {
      "src": require("../../assets/images/icons/eye-off-icon.svg")
    },
    on: {
      "click": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    }
  })])]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    key: "password",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])], 1) : _vm._e(), (_vm.user.default_user) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('password_confirmation')
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.user.password_confirmation),
      expression: "user.password_confirmation",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('confirmed:password'),
      expression: "'confirmed:password'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "activation-password_confirmation",
      "type": _vm.showPasswordConfirmation ? 'text-open-password' : 'password',
      "name": "password_confirmation",
      "placeholder": "Repetir Senha"
    },
    domProps: {
      "value": (_vm.user.password_confirmation)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.user, "password_confirmation", $event.target.value)
      }
    }
  }), (_vm.showPasswordConfirmation) ? _c('div', {
    staticClass: "input-group-addon open-password"
  }, [_c('img', {
    staticClass: "icon-size",
    attrs: {
      "src": require("../../assets/images/icons/open-eye.svg")
    },
    on: {
      "click": function($event) {
        _vm.showPasswordConfirmation = !_vm.showPasswordConfirmation
      }
    }
  })]) : _c('div', {
    staticClass: "input-group-addon open-password"
  }, [_c('img', {
    staticClass: "icon-size",
    attrs: {
      "src": require("../../assets/images/icons/eye-off-icon.svg")
    },
    on: {
      "click": function($event) {
        _vm.showPasswordConfirmation = !_vm.showPasswordConfirmation
      }
    }
  })])]), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password_confirmation')),
      expression: "errors.has('password_confirmation')"
    }],
    key: "password_confirmation",
    staticClass: "help-block text-left"
  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1) : _vm._e(), _c('button', {
    staticClass: "btn btn-block btn-primary submit-button",
    attrs: {
      "type": "submit",
      "disabled": _vm.errors.any()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit()
      }
    }
  }, [_vm._v("Ativar conta")]), (_vm.apiErrorMessages.length > 0) ? _c('router-link', {
    staticClass: "login-link",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Login")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ee11c89!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/activation.vue
// module id = 1036
// module chunks = 1